import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Impressum = () => {
  const { language } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow bg-white py-20">
        <div className="container mx-auto px-6 max-w-[780px]">
          {language === 'de' ? (
            // DEUTSCH
            <>
              <h1 className="text-4xl md:text-5xl font-display font-bold text-brand-dark mb-8">
                Impressum
              </h1>

              <div className="space-y-6 text-gray-700 leading-relaxed" style={{ fontSize: '16px', lineHeight: '1.8' }}>
                <div>
                  <p className="font-medium text-brand-dark">Mustafa Ciftci</p>
                  <p>Internetdienstleistungen, Foto- und Videografen</p>
                  <p>Douglasienweg 1</p>
                  <p>71364 Winnenden</p>
                </div>

                <div>
                  <h2 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Kontakt
                  </h2>
                  <p>Telefon: 01624071824</p>
                  <p>E-Mail: <a href="mailto:cift.studio@gmail.com" className="text-brand-gold hover:underline">cift.studio@gmail.com</a></p>
                </div>

                <div>
                  <h2 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Verbraucherstreitbeilegung/Universalschlichtungsstelle
                  </h2>
                  <p>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>
            </>
          ) : (
            // ENGLISH
            <>
              <h1 className="text-4xl md:text-5xl font-display font-bold text-brand-dark mb-8">
                Legal Notice
              </h1>

              <div className="space-y-6 text-gray-700 leading-relaxed" style={{ fontSize: '16px', lineHeight: '1.8' }}>
                <div>
                  <p className="font-medium text-brand-dark">Mustafa Ciftci</p>
                  <p>Internet Services, Photography & Videography</p>
                  <p>Douglasienweg 1</p>
                  <p>71364 Winnenden</p>
                  <p>Germany</p>
                </div>

                <div>
                  <h2 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Contact
                  </h2>
                  <p>Phone: +491624071824</p>
                  <p>E-Mail: <a href="mailto:cift.studio@gmail.com" className="text-brand-gold hover:underline">cift.studio@gmail.com</a></p>
                </div>

                <div>
                  <h2 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Consumer Dispute Resolution
                  </h2>
                  <p>
                    We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Impressum;
